/**
 * WRITE 권한이 있을 때만 children을 렌더.
 * 등록·저장·삭제 등 쓰기 액션 래퍼.
 */
import { useMenuAccess } from '@/layouts/MenuAccessContext';
import React from 'react';

type MenuWriteGateProps = {
  children: React.ReactNode;
  /** true면 WRITE 없을 때 null 대신 fallback */
  fallback?: React.ReactNode;
};

export const MenuWriteGate: React.FC<MenuWriteGateProps> = ({
  children,
  fallback = null,
}) => {
  const { canWrite } = useMenuAccess();
  if (!canWrite) return <>{fallback}</>;
  return <>{children}</>;
};
